import React from 'react';
import PropTypes from 'prop-types';
import Icon from 'components/Icon';
import Styled from './styles';

/**
 *  ColorBar is a custom cellRenderer component for cells in ColorBar columns.
 */
const ColorBar = ({
  value, valueIconMap, valueColorMap, wrapperProps, iconWrapperProps, iconProps, ...otherProps
}) => {
  // This is for style the wrapping div of this component managed by Ag-grid. This cannot be moved into style sheet as css can't select parent container.
  if (otherProps.reactContainer) {
    otherProps.reactContainer.style.height = '100%'; // eslint-disable-line no-param-reassign
  }
  return (
    <Styled.ColorBar {...otherProps}>
      <Styled.ColorBarWrapper value={valueColorMap ? valueColorMap[value] : value} {...wrapperProps} />
      <Styled.IconWrapper {...iconWrapperProps}>
        <Icon src={valueIconMap[value]} ariaLabel={value} color={valueColorMap[value]} {...iconProps} />
      </Styled.IconWrapper>
    </Styled.ColorBar>
  );
};

ColorBar.propTypes = {
  /* children */
  value: PropTypes.string,
  /* Map of keys and corresponding icons. */
  valueIconMap: PropTypes.shape({}),
  /* Map of keys and corresponding colors. */
  valueColorMap: PropTypes.shape({}),
  /* Props just for ColorBarWrapper */
  wrapperProps: PropTypes.shape({}),
  /* Props just for IconWrapper */
  iconWrapperProps: PropTypes.shape({}),
  /* Props just for Icon */
  iconProps: PropTypes.shape({})
};
ColorBar.defaultProps = {
  valueIconMap: {},
  valueColorMap: {},
  wrapperProps: {},
  iconWrapperProps: {},
  iconProps: {},
  value: ''
};
export default ColorBar;
